export const DefaultTabSources = {
  Unsplash: "Unsplash",
  Library: "Library",
  Link: "Link",
  Attachments: "From page",
  Video: "Video",
  Users: "Users",
};
